import { Modal, ModalFullscreen, useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { EPageName } from '../../constants/pages';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import type { ReactElement } from 'react';

interface IModalFormProps {
  isOpen: boolean;
  onCloseModal: (open: boolean) => void;
  form: ReactElement;
  modalPageType: EPageName;
}

export const ModalForm: React.FC<IModalFormProps> = ({ isOpen, form, onCloseModal, modalPageType }) => {
  const device = useDeviceType();
  const isBuyerLanding = modalPageType === EPageName.LandingBuyer;
  const isModalWindowShown = isBuyerLanding && device === 'phone';

  return isModalWindowShown ? (
    <ModalFullscreen open={isOpen} onClose={() => onCloseModal(false)} theme="white" escape>
      <div className={style['form_container']}>
        <div className={style['form_header']}>
          <IconActionClose16 color="icon-secondary-default" onClick={() => onCloseModal(false)} />
        </div>
        <div className={style['form_content']}>{form}</div>
      </div>
    </ModalFullscreen>
  ) : (
    <Modal size="S" open={isOpen} onOpenChange={onCloseModal} header={<div className={style['head']} />} body={form} />
  );
};
